import { NOTIFICATIONS_REQUEST, RESET_NOTIFICATIONS } from "../action.types";
import axios from "axios";

const authToken = localStorage.getItem(process.env.REACT_APP_AUTH_TOKEN);

const getNotf = payload => ({
  type: NOTIFICATIONS_REQUEST,
  payload: payload.data.values
});

export const getNotifications = (page = 1, pageSize = 1000) => {
  return dispatch => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_API}orderServices/notification?page=${page}&pageSize=${pageSize}`,
      headers: { Authorization: `Bearer ${authToken}` }
    })
      .then(value => {
        dispatch(getNotf(value));
      })
      .catch(error => {
        console.log(error);
      });
  };
};

export const resetNotifications = () => {
  return {
    type: RESET_NOTIFICATIONS
  };
};



// WEBPACK FOOTER //
// ./src/redux/notification/notifications.actions.js